function ChangePassword() {
  return <div>This is Change Password</div>;
}

export default ChangePassword;
